// src/pages/FulfillmentPage/hooks/useDrivers.ts
import { useState, useEffect } from "react";
import { listDrivers, assignDriverToFulfillment } from "../../../api/fulfillmentApi";
import { Driver, Fulfillment } from "../types";

export function useDrivers(fulfillment: Fulfillment | null) {
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [driverLoading, setDriverLoading] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState<number | "">("");

  useEffect(() => {
    const loadDrivers = async () => {
      if (!fulfillment) return;
      
      const isLocal = String(fulfillment.type).toLowerCase() === "local_delivery";
      const canAssign = isLocal && fulfillment.status === "READY";

      if (!canAssign) return;

      setDriverLoading(true);
      try {
        const list = await listDrivers();
        setDrivers(list);
        if (fulfillment.delivery_driver_id) {
          setSelectedDriverId(fulfillment.delivery_driver_id);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setDriverLoading(false);
      }
    };

    loadDrivers();
  }, [fulfillment?.id, fulfillment?.status, fulfillment?.type]);

  const assignDriver = async (fulfillmentId: number, driverId: number) => {
    await assignDriverToFulfillment(fulfillmentId, driverId);
  };

  return {
    drivers,
    driverLoading,
    selectedDriverId,
    setSelectedDriverId,
    assignDriver,
  };
}